import React from 'react';
import { CircularProgress } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';

import MailNotificationsCard from './components/MailNotificationCardsComponents';
import MailNotificationsClientToggleableCard from './components/MailNotificationClientToggleableCardComponents';

const useStyles = makeStyles({
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const MailNotificationView = ({ props }) => {
  const { t, state, setAllowToChangedElements } = props;

  const classes = useStyles();

  if (state.adminMailing.length === 0 && state.clientMailing.length === 0) {
    return (
      <div className={classes.circularProgress}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <MailNotificationsCard
        mailForAdmin={true}
        title={t('mailNotifications.cardTitle.admin')}
        mailing={state.adminMailing}
        defaultConfigFromBrand={state.defaultConfigFromBrand}
        setAllowToChangedElements={setAllowToChangedElements}
      />
      <MailNotificationsCard
        title={t('mailNotifications.cardTitle.client')}
        mailing={state.clientMailing}
        defaultConfigFromBrand={state.defaultConfigFromBrand}
        setAllowToChangedElements={setAllowToChangedElements}
      />
      <MailNotificationsClientToggleableCard
        clientMailing={state.clientMailing}
        adminMailing={state.adminMailing}
        mailing={state.clientToggleableMailing}
      />
    </>
  );
};

export default MailNotificationView;
